import { Box } from "@mui/material";
import React from "react";

const Starred = () => {
  return <Box>Starred</Box>;
};

export default Starred;
